/**
 * @typedef {Object} Dates
 * @property {number|Date} from - Начальная дата.
 * @property {number|Date} to - Конечная дата.
 */

/**
 * @typedef {Object} timezoneInfo
 * @property {string}  short
 * */

import hasTimeLimit from "~/js/modules/components/Restrictions/hasTimeLimit";
import hasAmountLimit from "~/js/modules/components/Restrictions/hasAmountLimit";
import { I18n } from "~/js/tools/i18n";
export default {
  /**
   * @param {DataForm} formData - Настройки компонента ограничений по времени.
   */
  getRestrictionsFormWrapper(formData) {
    const $i18n = new I18n(["ru", "ru", "en"][formData.languageId]);
    const wrapper = document.createElement("div");
    wrapper.classList.add("qform-restrictions-wrapper");
    const messageContainer = document.createElement("div");
    messageContainer.classList.add("qform-restrictions-message");

    // Создание кнопки копирования ссылки (вынесено в отдельную функцию)
    const createCopyLinkButton = () => {
      const linkContainer = document.createElement("div");
      linkContainer.classList.add("qform-restrictions-link");
      const copyLinkBtn = document.createElement("button");
      copyLinkBtn.type = "button";
      copyLinkBtn.innerText = $i18n.t('restrictions.copyLink.mainLabel');
      copyLinkBtn.onclick = function () {
        window.navigator.clipboard?.writeText(window.location.href).then(() => {
          copyLinkBtn.classList.add("--qform-success-copied");
          copyLinkBtn.innerText = $i18n.t('restrictions.copyLink.successLabel');
        });
      };
      linkContainer.append(copyLinkBtn);
      return linkContainer;
    };

    // Обработка временных ограничений
    if (formData.hasTimeLimit) {
      const now = new Date();
      const start = new Date(formData.startTime);
      const end = new Date(formData.endTime);

      // Общие параметры для временных ограничений
      const timeLimitParams = {
        dates: {
          from: formData.startTime,
          to: formData.endTime
        },
        timezoneInfo: {
          short: formData.timezoneShortValue
        },
        lang: ["ru", "ru", "en"][formData.languageId]
      };
      if (now < start || now > end) {
        hasTimeLimit(messageContainer, timeLimitParams);
        wrapper.append(messageContainer, createCopyLinkButton());
        return wrapper;
      } else if (now > start && now <= end) {
        if (formData.hasAmountLimit && !formData.active) {
          document.querySelector(`[data-formid=${formData.formID}]`).classList.add("--qform-hide-form", "--qform-has-amount");
          hasAmountLimit(messageContainer, formData);
          wrapper.append(messageContainer);
          return wrapper;
        }
        hasTimeLimit(messageContainer, timeLimitParams);
        wrapper.append(messageContainer, createCopyLinkButton());
        return wrapper;
      }
    }

    // Обработка ограничений по количеству
    if (formData.hasAmountLimit && !formData.active) {
      document.querySelector(`[data-formid=${formData.formID}]`).classList.add("--qform-hide-form", "--qform-has-amount");
      hasAmountLimit(messageContainer, formData);
      wrapper.append(messageContainer);
      return wrapper;
    }
    return wrapper;
  }
};